export default {
	form: {
		required_error: '此字段为必填',
		max_length_exceeded_error: '内容过长（最多 {{length}} 个字符）'
	},
	legal: {
		copyright: 'Gerositus Sàrl - 保留所有权利',
		i_consent: '我同意',
		agreement_title: '协议',
		agreement_content:
			'使用 Gerositus 即表示您同意我们的 <1>条款与条件</1> 和 <2>隐私政策</2>。',
		agreement_terms_conditions: '条款与条件',
		agreement_privacy_policy: '隐私政策',
	},
	navigation: {
		home: '首页'
	},
	yes: '是',
	no: '否',
	not_defined: '未定义',
	please_wait: '请稍候',
	search: '搜索',
	upgrade_required: '需要升级',
	create_project_title: '您希望达成什么目标？',
	click_to_change: '点击更改',
	click_to_create_one: '点击<button>创建</button>',
	no_goal: '无目标',
	auth: {
		token_expiring_soon: '您的会话将在 {{minutes}} 分钟后过期',
		token_expired: '会话已过期，将跳转到登录页。',
		token_check_error: '检查令牌时出错',
		session_expiring: '会话即将过期，请重新登录。剩余时间：{{time}}'
	},
	bot: {
		placeholder: '在此输入您的问题',
		security_notice: '私有隔离的 AI。您的对话保持机密。'
	},
	tutorial: {
		button: '教程',
		exit_title: '退出教程',
		exit_confirm: '确定要退出教程吗？'
	},
	subscription: {
		billing_monthly: '按月',
		billing_yearly: '按年',
		billing_yearly_save: '（省 20%）',
		choose_now: '立即选择'
	},
	icons: {
		used: '已使用',
		unused: '未使用'
	},
	theme: {
		selector: '主题选择',
		current_theme: '当前主题',
		change_theme: '更改主题'
	},
	no_description: '无描述',
	situation_analysis: {
		title: '情境分析',
		description: '自动分析组织、公司或情境',
		organization_label: '组织 / 公司',
		organization_placeholder: '要分析的组织名称',
		subject_label: '主题',
		subject_placeholder: '分析主题（已预填项目名称）',
		launch_analysis: '运行分析',
		analysis_in_progress: '分析进行中…',
		complete_analysis: '结束分析',
		waiting_analysis: '等待分析…',
		waiting_summary: '等待摘要…',
		waiting_stakes: '等待利害关系…',
		waiting_risks: '等待风险…',
		waiting_openings: '等待突破口…',
		waiting_stakeholders: '等待利益相关方…',
		context_title: '总体背景',
		summary_title: '摘要',
		stakes_title: '利害关系',
		risks_title: '风险',
		openings_title: '突破口',
		stakeholders_title: '利益相关方',
		status: '状态',
		likelihood: '可能性',
		impact: '影响',
		stakeholder: {
			importance_label: '相对重要性',
			propensity_label: '倾向',
			engagement_label: '参与度',
			importance_values: {
				low: '低',
				medium: '中',
				high: '高'
			},
			propensity_values: {
				green: '支持',
				neutral: '中性',
				orange: '紧张',
				red: '对立'
			},
			engagement_values: {
				inactive: '不活跃',
				neutral: '中性',
				low: '低',
				medium: '中',
				high: '高'
			},
			polarity_values: {
				positive: '支持',
				negative: '反对'
			}
		},
		risk_category_values: {
			operational: '运营',
			strategic: '战略',
			existential: '存亡'
		}
	},
	ai_project_generation: {
		checkbox_label: '使用 AI 生成内容',
		checkbox_tooltip: "使用标题、使命、描述和下方列出的场景。仅在您点击“创建项目”后才会启动公开 AI 搜索。",
		title: 'AI 项目生成',
		go_to_project: '进入项目',
		create_project: '创建项目',
		include_in_project_aria: '将此条目纳入项目',
		creation_modal_title: '正在创建条目',
		creation_progress_text: '已创建 {{current}} / {{total}} 个条目',
		error_title: '生成错误',
		complete_title: '生成完成',
		complete_description:
			'项目已成功丰富。AI 已识别关键利益相关方、利害关系、风险与突破口。',
		summary_title: '分析摘要',
		initializing_text: '正在准备深度分析… 可能需要 6 到 10 分钟。',
		include_in_project_tooltip: '勾选后，点击「创建项目」时将在项目中创建该条目。',
		language_code: 'zh',
		patience_with_scenarios: '场景生成较为复杂，可能需要几分钟。感谢您的耐心等待。',
		patience_no_scenarios: '深度分析可能需要几分钟。感谢您的耐心等待。',
		phases: {
			initializing: '启动',
			deep_research: '研究',
			analyzing: 'AI 分析',
			stakeholders: '利益相关方',
			stakes: '利害关系',
			risks: '风险',
			openings: '突破口',
			summary: '摘要',
			fishbone: '行动计划',
			entities: '实体',
			scenarios: '场景',
			completed: '完成',
			error: '错误'
			},
		section_title: "AI 生成详情",
		disclosure_public_title: "发往公开 AI",
		disclosure_public_sub: "网络搜索。仅接收下方的中立预览 — 无意图、无目标。",
		disclosure_private_title: "私有、隔离的 AI",
		disclosure_private_sub: "在隔离环境中运行。无再训练，无外发数据。处理标题、使命、描述和场景。",
		zone_public: "发送至公开 AI",
		zone_private: "私有 — 不发送至公开 AI",
		field_private_chip: "私有且安全",
		field_private_tooltip: "由隔离环境中的私有 AI 处理。无再训练，无外发数据。",
		preview_title: "搜索预览",
		preview_refresh: "重新生成预览",
		preview_hint: "中立化您的主题 — 不留意图痕迹。这正是将发送到公开搜索的内容 — 仅在您确认后才发送。",
		preview_placeholder: "请至少填写项目标题以生成预览。",
		launch_generation: "启动生成",
		fishbone_source: '源文本',
		scenario_n: '场景 {{n}}',
		scenario_optimistic: '乐观',
		scenario_baseline: '最可能',
		scenario_pessimistic: '悲观',
		scenario_pending: '待处理',
		scenario_triggers: '触发事件',
		scenario_action_window: '行动窗口',
		scenario_detail: '详细分析',
		dismiss: '忽略 AI 建议并创建项目',
		save_pdf: '另存为 PDF',
		save_hint: '您可以在进入项目前保存此分析。',
		scenario_impacts: '实体影响',
		data: {
			scenarios: '前瞻性场景',
			fishbone: '战略行动计划'
		}
	},
	scenario_elaboration: {
		title: 'AI 场景推演',
		hypothesis: '假设',
		initializing: '正在初始化分析…',
		error_title: '推演错误',
		complete_title: '推演完成',
		complete_description: '场景已成功推演，更改已应用。',
		analysis_preview: '初步分析',
		applied_changes: '已应用的更改',
		stakeholders_modified: '位利益相关方已修改',
		stakes_modified: '项利害关系已修改',
		risks_modified: '项风险/突破口已修改',
		indicators_modified: '项指标已修改',
		new_elements: '新增',
		steps: {
			started: '开始',
			started_desc: '正在初始化分析…',
			fetching_project: '获取项目',
			fetching_project_desc: '正在加载项目数据…',
			deep_research: '初步分析',
			deep_research_desc: '深度情境分析…',
			ai_analysis: 'AI 分析',
			ai_analysis_desc: 'AI 正在分析假设的影响…',
			reformatting: '格式化',
			reformatting_desc: '正在整理结果…',
			processing_stakeholders: '利益相关方',
			processing_stakeholders_desc: '正在计算利益相关方影响…',
			processing_stakes: '利害关系',
			processing_stakes_desc: '正在计算利害关系影响…',
			processing_risks: '风险',
			processing_risks_desc: '正在计算风险影响…',
			processing_indicators: '指标',
			processing_indicators_desc: '正在计算指标影响…',
			completed: '已完成',
			completed_desc: '分析成功完成',
			error: '错误',
			error_desc: '发生错误'
		}
	}
};
